import type { FileRouter } from 'uploadthing/server'
import { createUploadThing } from '../../../../actions/Attachments/uploadthing'

export const { UploadButton, uploadFiles } = createUploadThing<FileRouter>()
